<template>
	<div :class="[spaceY]">
		<slot />

		<div class="py-7 text-center">
			<CarbarLink :href="viewAllUrl" target="_blank" :text="viewAllText">
				<CarbarButton
					v-if="showButton"
					:is-full-width="false"
					:rounded="rounded"
					:background-color="buttonBgColor"
					:font-weight="fontWeight"
					:shadow="shadow"
				>
					<span class="text-white">
						{{ viewAllText }}
					</span>
				</CarbarButton>
			</CarbarLink>
		</div>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'

const props = defineProps({
	spaceY: {
		type: String,
		default: 'space-y-0',
		required: false,
	},
	viewAllUrl: {
		type: String,
		default: 'https://support.carbar.com.au',
		required: false,
	},
	viewAllText: {
		type: String,
		default: 'View all FAQs',
		required: false,
	},
	showButton: {
		type: Boolean,
		default: false,
		required: false,
	},
	rounded: {
		type: String,
		default: '',
		required: false,
	},
	buttonBgColor: {
		type: String,
		default: '',
		required: false,
	},
	fontWeight: {
		type: String,
		default: 'font-medium',
		required: false,
	},
	shadow: {
		type: String,
		required: false,
	},
})
</script>
